import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTreeview } from 'vuetify/lib/components/VTreeview';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "pa-6",
    attrs: {
      "fluid": ""
    }
  }, [_c(VRow, {
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c('h2', [_vm._v("Dashboard")])])], 1), _c(VCard, {
    staticStyle: {
      "border-radius": "15px"
    }
  }, [_c(VRow, {
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    staticClass: "pl-4 pr-4",
    attrs: {
      "cols": "12"
    }
  }, [_c('h2', {
    staticClass: "mb-6 mt-2"
  }, [_vm._v("Classroom K12")])]), _c(VCol, {
    staticClass: "pl-4 pr-4",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "font-weight-medium mb-4 mt-0"
  }, [_vm._v("Overview:")]), _c(VCard, {
    staticStyle: {
      "border-radius": "15px"
    }
  }, [_c(VRow, {
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    staticClass: "ma-4"
  }, [_c(VCardTitle, [_c(VIcon, {
    staticClass: "pr-2",
    attrs: {
      "color": _vm.$store.state.app.color,
      "size": "55"
    }
  }, [_vm._v("mdi-heart-pulse")]), _c(VRow, {
    attrs: {
      "align": "start"
    }
  }, [_c('div', {
    staticClass: "text-caption grey--text text-uppercase"
  }, [_vm._v("Heart rate")]), _c('div', [_c('span', {
    staticClass: "text-h4 font-weight-black"
  }, [_vm._v("103")]), _c('strong', [_vm._v("BPM")])])])], 1)], 1), _c(VCol, {
    staticClass: "ma-4"
  }, [_c(VCardTitle, [_c(VIcon, {
    staticClass: "pr-2",
    attrs: {
      "color": _vm.$store.state.app.color,
      "size": "55"
    }
  }, [_vm._v("mdi-chart-doughnut")]), _c(VRow, {
    attrs: {
      "align": "start"
    }
  }, [_c('div', {
    staticClass: "text-caption grey--text text-uppercase"
  }, [_vm._v("Indound Data")]), _c('div', [_c('span', {
    staticClass: "text-h4 font-weight-black"
  }, [_vm._v("1.030")]), _c('strong', [_vm._v("$")])])])], 1)], 1), _c(VCol, {
    staticClass: "ma-4"
  }, [_c(VCardTitle, [_c(VIcon, {
    staticClass: "pr-2",
    attrs: {
      "color": _vm.$store.state.app.color,
      "size": "55"
    }
  }, [_vm._v("mdi-chart-line")]), _c(VRow, {
    attrs: {
      "align": "start"
    }
  }, [_c('div', {
    staticClass: "text-caption grey--text text-uppercase"
  }, [_vm._v("Data-Points")]), _c('div', [_c('span', {
    staticClass: "text-h4 font-weight-black"
  }, [_vm._v("10")]), _c('strong', [_vm._v("EHX")])])])], 1)], 1), _c(VCol, {
    staticClass: "ma-4"
  }, [_c(VCardTitle, [_c(VIcon, {
    staticClass: "pr-2",
    attrs: {
      "color": _vm.$store.state.app.color,
      "size": "55"
    }
  }, [_vm._v("mdi-alarm-check")]), _c(VRow, {
    attrs: {
      "align": "start"
    }
  }, [_c('div', {
    staticClass: "text-caption text-uppercase"
  }, [_vm._v("Events")]), _c('div', [_c('span', {
    staticClass: "text-h4 font-weight-black"
  }, [_vm._v("205")]), _c('strong', [_vm._v("p.ah")])])])], 1)], 1)], 1)], 1)], 1), _vm._l(_vm.tiles, function (tile, i) {
    return _c(VCol, {
      key: i,
      staticClass: "mt-6 pl-4 pr-4",
      attrs: {
        "cols": "12",
        "sm": "6",
        "lg": "4"
      }
    }, [_c('p', {
      staticClass: "font-weight-medium mb-4 mt-0"
    }, [_vm._v(_vm._s(tile.title) + ":")]), _c(VCard, {
      staticClass: "content-card"
    }, [_c('div', {
      class: 'misc-' + _vm.$store.state.app.color
    }, [_c(VCardTitle, {
      staticClass: "content-card-pa"
    }, [_c(VRow, {
      attrs: {
        "align": "start"
      }
    }, [_c('div', {
      staticClass: "text-caption text-uppercase"
    }, [_c('p', {
      staticStyle: {
        "color": "#fff"
      }
    }, [_vm._v("Events")])]), _c('div', [_c('span', {
      staticClass: "text-h4 font-weight-black",
      staticStyle: {
        "color": "#fff"
      }
    }, [_vm._v("205")]), _c('strong', {
      staticStyle: {
        "color": "#fff"
      }
    }, [_vm._v("p.ah")])])]), _c(VAvatar, {
      attrs: {
        "size": "80"
      }
    }, [_c('img', {
      attrs: {
        "src": tile.image,
        "alt": "avatar"
      }
    })])], 1)], 1), _c(VCardText, {
      staticClass: "content-card-pa"
    }, [_c(VRow, [_c(VCol, {
      attrs: {
        "align-self": "center"
      }
    }, [_c('p', {
      staticClass: "mb-0"
    }, [_vm._v("Service")])]), _c(VCol, {
      attrs: {
        "cols": "8"
      }
    }, [_c(VProgressLinear, {
      attrs: {
        "color": _vm.$store.state.app.color
      },
      model: {
        value: _vm.valueDeterminate1,
        callback: function ($$v) {
          _vm.valueDeterminate1 = $$v;
        },
        expression: "valueDeterminate1"
      }
    })], 1)], 1), _c(VRow, [_c(VCol, {
      attrs: {
        "align-self": "center"
      }
    }, [_c('p', {
      staticClass: "mb-0"
    }, [_vm._v("Progress")])]), _c(VCol, {
      attrs: {
        "cols": "8"
      }
    }, [_c(VProgressLinear, {
      attrs: {
        "color": _vm.$store.state.app.color
      },
      model: {
        value: _vm.valueDeterminate2,
        callback: function ($$v) {
          _vm.valueDeterminate2 = $$v;
        },
        expression: "valueDeterminate2"
      }
    })], 1)], 1), _c(VRow, [_c(VCol, {
      attrs: {
        "align-self": "center"
      }
    }, [_c('p', {
      staticClass: "mb-0"
    }, [_vm._v("Battery")])]), _c(VCol, {
      attrs: {
        "cols": "8"
      }
    }, [_c(VProgressLinear, {
      attrs: {
        "color": "red"
      },
      model: {
        value: _vm.valueDeterminate3,
        callback: function ($$v) {
          _vm.valueDeterminate3 = $$v;
        },
        expression: "valueDeterminate3"
      }
    })], 1)], 1)], 1)], 1)], 1);
  }), _c(VCol, {
    staticClass: "mt-6 pl-4 pr-4",
    attrs: {
      "cols": "12",
      "sm": "6",
      "lg": "4"
    }
  }, [_c('p', {
    staticClass: "font-weight-medium mb-4 mt-0"
  }, [_vm._v("Data-Integrity:")]), _c(VCard, {
    staticClass: "content-card"
  }, [_c(VCardTitle, {
    staticClass: "content-card-pa"
  }, [_c(VIcon, {
    attrs: {
      "size": "20"
    }
  }, [_vm._v("mdi-arrow-left-bold-circle-outline")]), _c(VRow, {
    attrs: {
      "align": "center"
    }
  }, [_c('div', [_c('span', {
    staticClass: "font-weight-black"
  }, [_vm._v("Humidity")])])]), _c(VIcon, {
    attrs: {
      "size": "20"
    }
  }, [_vm._v("mdi-arrow-right-bold-circle-outline")])], 1), _c(VCardText, {
    staticClass: "content-card-pa"
  }, [_c(VRow, {
    attrs: {
      "align": "center"
    }
  }, [_c(VProgressCircular, {
    attrs: {
      "rotate": -90,
      "size": 170,
      "width": 20,
      "value": _vm.Svalue,
      "color": _vm.$store.state.app.color
    }
  }, [_vm._v("\n                " + _vm._s(_vm.Svalue) + "%\n              ")])], 1)], 1)], 1)], 1), _c(VCol, {
    staticClass: "mt-6 pl-4 pr-4",
    attrs: {
      "cols": "12",
      "sm": "6",
      "lg": "4"
    }
  }, [_c(VCard, {
    staticClass: "content-card-small-top mb-2"
  }, [_c(VCardTitle, {
    staticClass: "content-card-pa-small"
  }, [_c(VRow, {
    attrs: {
      "align": "start"
    }
  }, [_c('div', {
    staticClass: "text-caption grey--text text-uppercase"
  }, [_vm._v("Monthly connections")]), _c('div', [_c('span', {
    staticClass: "text-h4 font-weight-black detail-text"
  }, [_vm._v("1.004.325")]), _c('strong', [_vm._v("coo")])])]), _c(VBtn, {
    class: 'v-btn--rounded bg-rounded-button-' + _vm.$store.state.app.color,
    attrs: {
      "color": _vm.$store.state.app.color,
      "icon": "",
      "info": "",
      "fab": "",
      "text": ""
    }
  }, [_c(VIcon, {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("mdi-key")])], 1)], 1)], 1), _c(VCard, {
    staticClass: "content-card-small-middle mb-2"
  }, [_c(VCardTitle, {
    staticClass: "content-card-pa-small"
  }, [_c(VRow, {
    attrs: {
      "align": "start"
    }
  }, [_c('div', {
    staticClass: "text-caption grey--text text-uppercase"
  }, [_vm._v("Temperature")]), _c('div', [_c('span', {
    staticClass: "text-h4 font-weight-black detail-text"
  }, [_vm._v("23")]), _c('strong', [_vm._v("°C")])])]), _c(VBtn, {
    class: 'v-btn--rounded bg-rounded-button-' + _vm.$store.state.app.color,
    attrs: {
      "color": _vm.$store.state.app.color,
      "icon": "",
      "info": "",
      "fab": "",
      "text": ""
    }
  }, [_c(VIcon, {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("mdi-heart")])], 1)], 1)], 1), _c(VCard, {
    staticClass: "content-card-small-middle mb-2"
  }, [_c(VCardTitle, {
    staticClass: "content-card-pa-small"
  }, [_c(VRow, {
    attrs: {
      "align": "start"
    }
  }, [_c('div', {
    staticClass: "text-caption grey--text text-uppercase"
  }, [_vm._v("Level")]), _c('div', [_c('span', {
    staticClass: "text-h4 font-weight-black detail-text"
  }, [_vm._v("1,6")]), _c('strong', [_vm._v("bar")])])]), _c(VBtn, {
    class: 'v-btn--rounded bg-rounded-button-' + _vm.$store.state.app.color,
    attrs: {
      "color": _vm.$store.state.app.color,
      "icon": "",
      "info": "",
      "fab": "",
      "text": ""
    }
  }, [_c(VIcon, {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("mdi-plus")])], 1)], 1)], 1), _c(VCard, {
    staticClass: "content-card-small-bottom"
  }, [_c('div', {
    staticClass: "misc-primary"
  }, [_c(VCardTitle, {
    staticClass: "content-card-pa-small"
  }, [_c(VAvatar, {
    attrs: {
      "size": "50"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.imagetemp,
      "alt": "avatar"
    }
  })]), _c(VRow, {
    staticStyle: {
      "text-align": "-webkit-right"
    },
    attrs: {
      "align": "start"
    }
  }, [_c('div', {
    staticClass: "text-caption text-uppercase",
    staticStyle: {
      "color": "#fff"
    }
  }, [_vm._v("Revenue")]), _c('div', [_c('span', {
    staticClass: "text-h4 font-weight-black detail-text",
    staticStyle: {
      "color": "#fff"
    }
  }, [_vm._v("1.004")]), _c('strong', {
    staticStyle: {
      "color": "#fff"
    }
  }, [_vm._v("$")])])])], 1)], 1)])], 1), _c(VCol, {
    staticClass: "pl-4 pr-4 pt-4",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('p', {
    staticClass: "font-weight-medium mb-4 mt-0"
  }, [_vm._v("Digital-Twin Hierarchy:")]), _c(VCard, {
    staticClass: "content-card",
    staticStyle: {}
  }, [_c(VCardText, {
    staticClass: "content-card-pa"
  }, [_c(VTreeview, {
    staticStyle: {
      "overflow": "auto",
      "height": "320px"
    },
    attrs: {
      "items": _vm.treeItems,
      "search": _vm.search,
      "filter": _vm.filter,
      "open": _vm.open
    },
    on: {
      "update:open": function ($event) {
        _vm.open = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "prepend",
      fn: function ({
        item
      }) {
        return [item.children ? _c(VIcon, {
          class: _vm.color + '--text',
          domProps: {
            "textContent": _vm._s(`mdi-${item.id === 1 ? 'hexagon' : 'hexagon-outline'}`)
          }
        }) : _vm._e()];
      }
    }])
  })], 1)], 1)], 1), _c(VCol, {
    staticClass: "pl-4 pr-4 pt-4",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('p', {
    staticClass: "font-weight-medium mb-4 mt-0"
  }, [_vm._v("Fotos:")]), _c(VCarousel, {
    staticClass: "content-card"
  }, _vm._l(_vm.carouselItems, function (item, i) {
    return _c(VCarouselItem, {
      key: i,
      staticClass: "greyscale",
      attrs: {
        "src": item.src
      }
    });
  }), 1)], 1)], 2)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };